import { Img } from "components/Img";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { useCommunicationSetupSlice } from "features/CommunicationSetup/slice";
// import { RootState } from "controller/types";
// import { SetupLoader } from "core/components/SetupComponents/SetupLoader";

function extractTokens() {
    // Remove the '#' from the hash
    const hash = window.location.hash.substring(1);

    // Split the hash by '&' to get individual key-value pairs
    const params = hash.split('&');

    let accessToken: any = null;
    let longLivedToken: any = null;
    let data_access_expiration_time: any = null;
    let error: any = null;

    // Loop through the key-value pairs and extract tokens
    params.forEach(param => {
        const [key, value] = param.split('=');

        if (key === 'code') {
            accessToken = value;
        } else if (key === 'access_token') {
            accessToken = value;
        } else if (key === 'long_lived_token') {
            longLivedToken = value;
        } else if (key === 'data_access_expiration_time') {
            data_access_expiration_time = value;
        } else if (key === 'error') {
            error = value;
        }
    });

    return { accessToken, longLivedToken, data_access_expiration_time, error };
}

const MetaAuth = () => {
    // const dispatch = useDispatch();
    // const { actions } = useCommunicationSetupSlice();
    const [searchParams] = useSearchParams();
    // const code = searchParams?.get('code');
    const isError = searchParams?.get('error') || extractTokens()?.error;

    const code = extractTokens()?.accessToken;


    // const state: any = useSelector(
    //     (state: RootState) => state.communicationSetup,
    // );

    function saveAndRedirect() {
        const data = JSON.stringify({ ID: code, URL: 'facebook/pages' });
        const channel = new BroadcastChannel('popup_channel');
        channel.postMessage(data); // Send data to the parent
        channel.close(); // Close the channel after sending the message
        window.close();
    }

    useMemo(() => {
        if (!!code) {
            setTimeout(() => saveAndRedirect(), 2000);
        }
    }, [code]);


    // const HandleClose = () => {
    //     // const urlParams = new URLSearchParams(window.location.search);
    //     // const code = urlParams.get('code');

    //     // // window.opener.postMessage({ code }, 'https://d1g6axlwnukooh.cloudfront.net/');

    //     if (!isError) {
    //         const data = JSON.stringify({
    //             ID: code,
    //             URL: 'facebook/pages'
    //         });
    //         const channel = new BroadcastChannel('popup_channel');
    //         channel.postMessage(data); // Send data to the parent
    //         channel.close(); // Close the channel after sending the message
    //     }

    //     window.close();
    // }

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg relative max-w-[500px] flex flex-col items-center justify-center text-center">
                <div className="flex gap-4 items-center">
                    <Img src="/images/Logo.svg" className="w-5 h-5" />
                    <p className="text-xl">⇄</p>
                    <Img src="/images/Meta.svg" className="w-5 h-5" />
                </div>
                {isError ? <>
                    <h2 className="text-xl font-bold mb-4 break-words">Error! Meta authentication failed.</h2>
                </> : <>
                    <h2 className="text-xl font-bold mb-4 break-words">Hooray! Meta authentication was successful.</h2>
                    <h2 className="text-sm font-bold mb-4 break-words">You can now start sharing your photos to facebook and instagram.</h2>
                    <h2 className="text-sm font-bold mb-4 break-words">Redirecting you to the app. Please wait...</h2>
                </>}
                {/* <button
                    className="text-sm text-[white] bg-blue-500 px-4 py-2 rounded-md mt-4"
                    onClick={HandleClose}
                >
                    Close
                </button> */}
            </div>
        </div>

    );
}

export default MetaAuth;